import { NAME as namespace } from './constants';
import PaymentFormComponent from './components/PaymentForm';
import { paymentReducer as reducer, getPaymentMethodCurrency } from './reducer';
export var PaymentForm = PaymentFormComponent;
export var selectors = {
  getPaymentMethodCurrency: getPaymentMethodCurrency
};
export var payment = {
  namespace: namespace,
  reducer: reducer
};